import { useConfig } from "@/contexts/cdpConfig";
import { useFarbwelt } from "../../hooks/useFarbwelt";
import { useIsNewBuildProject } from "@/shared/hooks";
import { brandConfiguration } from "@/brands/config";
/**
 * Hook to determine if the BIC layout is enabled based on feature flags and context.
 * It checks if the BICLayout feature is enabled, if Farbwelt is not active,
 * if the app is not in preview mode, and if it is not a new build project.
 *
 * @returns {boolean} - Returns true if the BIC layout should be used, otherwise false.
 */
export const useIsBICLayout = () => {
    const { BICLayout } = brandConfiguration.featuresEnabled;
    const { isFarbweltActive } = useFarbwelt();
    const isPreviewMode = useConfig().previewMode;
    const isProject = useIsNewBuildProject();
    return BICLayout && !isFarbweltActive && !isPreviewMode && !isProject;
};
